import { saveAs } from 'file-saver'

const saveStreamableFile = (streamableFile: string, filename: string) => {
  const blob = new Blob([streamableFile], { type: 'application/javascript' })
  saveAs(blob, filename)
}

export default saveStreamableFile
